import { alpha, Theme } from '@mui/material';
import { SxProps } from '@mui/system';

/**
 * Styling for segmented ToggleButtonGroup filters (e.g. the emissions
 * Included/Excluded switch). Tints derive from the theme's primary colour so
 * partner-themed accounts see their own brand colour, not the Gaia green.
 */
export const segmentedToggleSx: SxProps<Theme> = (theme: Theme) => ({
  '& .MuiToggleButtonGroup-grouped': {
    px: 2.25,
    py: '5px',
    textTransform: 'none',
    fontSize: '14px',
    borderColor: alpha(theme.palette.primary.main, 0.5),
    color: 'primary.main',
    '&:not(:first-of-type)': {
      borderLeft: 0,
    },
    '&:hover': {
      borderColor: alpha(theme.palette.primary.main, 0.5),
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.primary.main, 0.09),
      color: 'primary.main',
      borderColor: alpha(theme.palette.primary.main, 0.5),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
      },
    },
  },
});
